module.exports = __webpack_public_path__ + "static/media/toggle_off_black_24dp.0ae1f64e.svg";